import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import { QuoteDisplay } from './QuoteDisplay';
import { UnlockQuote } from './UnlockQuote';
import { InjurySelector } from './InjurySelector';
import { Stack } from 'react-bootstrap';
import { SearchProfessionals } from '../Professionals/SearchProfessionals';





export function QuoteEstimatePopup({ show, bodyParts, leadId, onHide }) {


  const [withoutAttorneySum, setWithoutAttorneySum] = useState(() => bodyParts.map(() => 0));
  const [withAttorneySum, setWithAttorneySum] = useState(() => bodyParts.map(() => 0));
  const [severities, setSeverities] = useState(() => bodyParts.map(() => 1));

  const updateSeverity = (index, value) => {
    setSeverities(prev => {
      const next = [...prev];
      next[index] = Math.max(1, value);
      return next;
    });
  };

  // Save the ratings to the inquiry so the admin can post it to the marketplace as-is
  useEffect(() => {
    if (!leadId) return;
    const timer = setTimeout(() => {
      axios.put(`${process.env.REACT_APP_CORE_API}/lead/${leadId}/injuries`,
        bodyParts.map((p, i) => ({ bodyPart: p.bodyPart, injuryType: 'Injury', severity: severities[i] }))
      ).catch(err => console.error('Failed to save severities:', err));
    }, 600);
    return () => clearTimeout(timer);
  }, [leadId, severities, bodyParts]);

  const withAttorney = useMemo(
    () => withAttorneySum.reduce((sum, a) => sum + a, 0),
    [withAttorneySum]
  );
  const withoutAttorney = useMemo(
    () => withoutAttorneySum.reduce((sum, a) => sum + a, 0),
    [withoutAttorneySum]
  );

  const updateWithAttorney = (value, index) => {
    setWithAttorneySum(prev => {
      const newSum = [...prev];
      newSum[index] = value;
      return newSum;
    });
  }

  const updateWithoutAttorney = (value, index) => {
    setWithoutAttorneySum(prev => {
      const newSum = [...prev];
      newSum[index] = value;
      return newSum;
    });
  }

  function onClose() {
    onHide();
  }

  return (
    <>
      <Modal show={show} onHide={onHide} aria-labelledby="contained-modal-title-vcenter">
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Quote Estimate
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="grid-example">
          <Container>
            {bodyParts.length > 0 && (
              <div className="mb-3 text-center">
                <p className="mb-0" style={{ fontWeight: 'bold', color: '#212529' }}>
                  Rate the severity of each injury from 1-10
                </p>
              </div>
            )}
            <Stack gap={3}>
              {bodyParts.map((bodyPart, index) => (
                <InjurySelector
                  key={index}
                  bodyPart={bodyPart}
                  updateWithAttorney={updateWithAttorney}
                  updateWithoutAttorney={updateWithoutAttorney}
                  onSeverityChange={updateSeverity}
                  bodyIndex={index}
                />
              ))}
            </Stack>
            <br />
            <br />
                  <QuoteDisplay withAttorney={withAttorney} withoutAttorney={withoutAttorney} />
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  {/* <SearchProfessionals professional={"Lawyer"} sessionId={sessionId} setSessionId={setSessionId}/>
                  <SearchProfessionals professional={"Chiropractor"} sessionId={sessionId} setSessionId={setSessionId}/> */}
          </Container>
        </Modal.Body>


        <Modal.Footer>
          <Button onClick={onClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}